<template>
  <div class="webhead flex-row-between">
    <h1 class="logo"><router-link to='/'>Take Cloud</router-link></h1>
    <el-menu
      background-color='#324057'
      text-color='#bfcbd9'
      active-text-color='#20a0ff'
      :default-active='active'
      router
      class="nav"
      mode="horizontal"
    >
      <el-menu-item index="/boxlist">
        <i class="el-icon-menu"></i>设备列表
      </el-menu-item>
      <el-menu-item v-if="user_is_admin || user_is_pta" index="/myauth">
        <i class="el-icon-setting"></i>我的授权
      </el-menu-item>
      <el-menu-item v-if="user_is_pta" index="/unitlist">
        <i class="el-icon-d-caret"></i>合作厂商
      </el-menu-item>
      <el-menu-item v-if="user_is_pta" index="/help">
        <i class="el-icon-document"></i>帮助文档
      </el-menu-item>
      <el-menu-item v-if="user_is_admin || user_is_pta" index="/user">
        <i class="el-icon-star-off"></i>用户管理
      </el-menu-item>
      <el-menu-item v-if="user_is_pta" index="/version">
        <i class="el-icon-upload2"></i>发布版本
      </el-menu-item>
      <el-submenu v-if="user_is_pta" index="/">
        <template slot="title" width='120px'>统计信息</template>
          <el-menu-item index="/operationlog">
            操作日志
          </el-menu-item>
          <el-menu-item index="/timerlog">
            定时日志
          </el-menu-item>
          <el-menu-item index="/search">
            查询
          </el-menu-item>
      </el-submenu>
    </el-menu>

    <el-menu
      background-color='#324057'
      text-color='#bfcbd9'
      active-text-color='#bfcbd9'
      mode="horizontal"
      default-active='x'
      class="profile"
    >
      <el-submenu index="1" style="width: 200px; text-align: right" popper-class='profilesub'>
        <template slot="title">{{user_phone_no || '我的信息'}}</template>
        <el-menu-item index="1-1" @click.native="modalVisible = true">修改密码</el-menu-item>
        <el-menu-item index="1-2" @click.native="signout">退出</el-menu-item>
      </el-submenu>
    </el-menu>

    <el-dialog
      title="修改密码"
      :visible.sync="modalVisible"
      width='600px'
      :before-close="handleClose"
      :modal='false'
    >
      <el-form @submit.native.prevent ref='profile-form' :model="form" label-width='120px' :rules='rules'>
        <el-form-item label='手机号'>
          <el-input :value="user_phone_no" disabled/>
        </el-form-item>
        <el-form-item label='验证码' prop='sms_pw'>
          <el-row style="line-height: 40px">
            <el-col :span="15">
              <el-input v-model="form.sms_pw" placeholder='请输入验证码'/>
            </el-col>
            <el-col :span="8" :offset="1">
              <el-button @click="getCode" :disabled='!!timenum'>{{timenum? (timenum + '秒后重试') : '发送验证码'}}</el-button>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item label='新密码' prop='password'>
          <el-input v-model="form.password" type='password' placeholder='请输入新密码（6-20位，数字、字母、下划线）'/>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="handleOk">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { post } from "@/utils/http";
import { validatePassword } from "@/utils/util";

export default {
  data() {
    return {
      active: this.$route.path,
      modalVisible: false,
      form: {
        sms_pw: "",
        password: ""
      },
      timenum: 0,
      rules: {
        sms_pw: [
          { required: true, message: "请输入验证码", trigger: "blur" }
        ],
        password: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validatePassword("新密码"), trigger: "blur" }
        ]
      }
    };
  },
  computed: mapState([
    "user_is_admin",
    "user_is_pta",
    "user_phone_no",
    "user_id"
  ]),
  methods: {
    ...mapActions(["updateUser"]),
    signout() {
      this.$confirm("确定要退出吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info"
      }).then(() => {
        window.document.cookie =
          "take_cloud_token=0;expires=" + new Date(0).toUTCString();
        this.updateUser({});
        this.$router.push("/login");
      });
    },
    handleOk() {
      this.$refs["profile-form"].validate(async valid => {
        if (valid) {
          try {
            const res = await post("/user/Index/setPW", {
              ...this.form,
              id: this.user_id
            });
            if (res && res.rst == 0) {
              this.handleClose();
              this.$message({
                message: "修改成功",
                type: "success"
              });
              return
            }
            this.$message.error(res.msg);
          } catch (err) {
            this.$message.error("修改失败，请稍后重试");
          }
        } else {
          return false;
        }
      });
    },
    async getCode() {
      this.codereplay(60);
      try {
        const res = await post('/user/Index/sendSms', {
          phone_no: this.user_phone_no
        })
      } catch(err) {

      }
    },
    handleClose() {
      this.modalVisible = false;
      setTimeout(() => {
        this.resetForm();
        this.form = {};
      }, 200);
    },
    codereplay(i) {
      this.timenum = i;
      if (i <= 0) {
        return;
      }
      i--;
      setTimeout(() => {
        this.codereplay(i);
      }, 1000);
    },
    resetForm() {
      this.$refs["profile-form"].resetFields();
    }
  },
  name: "webhead"
};
</script>
<style lang="less" scoped>
.webhead {
  width: 100%;
  min-width: 1280px;
  height: 60px;
  line-height: 60px;
  font-weight: 700;
  position: fixed;
  top: 0;
  z-index: 999;
  background: #324057;
  padding: 0 32px;
  .logo {
    a {
      margin: 0;
      font-size: 24px;
      line-height: 60px;
      color: #fff;
      text-decoration: none;
    }
  }
  .nav {
  }
}
</style>
